import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Navbar, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logoImage from "../../assets/images/DailyTaskLogo.png";

const NavbarSection = () => {
  const navigate = useNavigate();
  return (
    <Navbar expand="lg" bg="white" className="shadow-sm py-3">
      <Container>
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <img src={logoImage} alt="Logo" height="60" className="me-2" />
          <span className="fw-bold text-dark fs-4">Daily Post Hub</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav className="align-items-center gap-3">
            <Nav.Link href="/" onClick={()=>navigate("/")}>Home</Nav.Link>
            <Nav.Link href="/aboutus" onClick={()=>navigate("/aboutus")}>About Us</Nav.Link>
            <Nav.Link href="/contactus" onClick={()=>navigate("/contactus")}>Contact Us</Nav.Link>
            <Button
              variant="success"
              size="sm"
              className="fw-bold"
              onClick={() => navigate("/login")}
            >
              Sign In
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarSection;
